<template>
  <div class="filters">
    <div class="categories">
      <button
        v-for="category in categories" :key="category.Name" class="selected">
          {{category.Name}}
      </button>
    </div>
  </div>
</template>

<script>
  import { functions } from '@/assets/script/functions.js'
  export default {
    props: ['recipe'],
    computed: {
      categories(){
        return functions.getUnique(this.recipe.Categories, 'Name')
      }
    }
  }
</script>
